import { formatISO } from "date-fns";
import { WorkspaceMember } from "@common/types/workspace";
import { CounterpartyFieldReviewDto } from "@common/schemas/counterpartyFieldReview.schema";
import { CounterpartyTinReview } from "@common/schemas/counterpartyTin.schema";
import type { CounterpartyFieldReviewer } from "./CounterpartyDetailsReview";

type ReviewRecord = Pick<
    CounterpartyFieldReviewDto | CounterpartyTinReview,
    "userId" | "createdAt"
>;

export function toFieldReviewer(
    review: ReviewRecord,
    members: WorkspaceMember[],
): CounterpartyFieldReviewer {
    const member = members.find((m) => m.user.id === review.userId);
    return {
        userId: review.userId,
        name: member?.user.name ?? `User ${review.userId}`,
        reviewedAt: formatISO(review.createdAt),
        avatarUrl: member?.user.avatar ?? null,
        iconColor: member?.user.iconColor ?? "",
        email: member?.user.email ?? null,
    };
}
